export default "__VITE_PUBLIC_ASSET__5f41415c__"